import React, { useState } from "react";
import Box from "@mui/material/Box";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";

type CheckboxGroupProps = {
  checkboxes: Array<{ label: string; value: string }>;
  label: string;
  onChange: (checkboxId: string, id?: string) => void;
  checked: Set<string>;
  display?: string;
  disabledCheckboxes?: Set<string>;
};
const CheckboxGroup = ({
  label,
  checkboxes,
  checked,
  onChange,
  display,
  disabledCheckboxes,
}: CheckboxGroupProps) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Box display={display}>
      <ListItemButton
        alignItems="flex-start"
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          "&:hover, &:focus": { "& svg": { opacity: 1 } },
        }}
      >
        <ListItemText primary={label} sx={{ margin: 1 }} />
        <KeyboardArrowDown
          sx={{
            opacity: 0,
            transform: isOpen ? "rotate(-180deg)" : "rotate(0)",
            transition: "0.2s",
            margin: 1.5,
          }}
        />
      </ListItemButton>
      {isOpen &&
        checkboxes.map((checkbox) => (
          <ListItemButton
            disabled={disabledCheckboxes?.has(checkbox.value)}
            key={checkbox.label}
            onClick={() => onChange(checkbox.value.toLowerCase())}
            sx={{ py: 0, minHeight: 32, color: "rgba(255,255,255,.8)" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <ListItemIcon>
                <Checkbox
                  disabled={disabledCheckboxes?.has(checkbox.value)}
                  id={checkbox.label}
                  key={checkbox.label}
                  checked={checked.has(checkbox.value.toLowerCase())}
                />
              </ListItemIcon>
              <ListItemText
                primary={checkbox.label.toUpperCase()}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: "medium",
                  color: "#fff",
                }}
                sx={{ marginTop: 1 }}
              />
            </div>
          </ListItemButton>
        ))}
    </Box>
  );
};

export default CheckboxGroup;
